import React, { useState , useRef, useCallback} from 'react';
import { Button, OverlayTrigger, Popover, Modal } from 'react-bootstrap'
import ReactGA from 'react-ga';
import "react-datepicker/dist/react-datepicker.css";
import ReCAPTCHA from 'react-google-recaptcha';
import Swal from 'sweetalert2';

export default function HomePage(props) {
    const [modalShow, setModalShow] = useState(true);

    const [captchaResponse, setCaptchaResponse] = useState(true);
    const [validationResponse, setValidationResponse] = useState(true);
    const [verificationResponse, setVerificationResponse] = useState(false);
    const [capchaToken, setCapchaToken] = useState('');
    const recaptchaRef = useRef(null);
    const [validToken, setValidToken] = useState('');

    const handleRecaptcha = useCallback((token) => {
        setCapchaToken(token || '');

        if(token.length > 0) {
            var captchaWidget = document.getElementById('captchaV');
            captchaWidget.style.border = '';

            setCaptchaResponse(true);
            setValidationResponse(true);
            setVerificationResponse(false);

            verifyCaptcha(token);
        }
    }, []);

    function onClickNext(referral = null) {

        //START Google Captcha

        // setCaptchaResponse(true);
        // setValidationResponse(true);
        
        var captchaWidget = document.getElementById('captchaV');
        if (validToken.length == 0) {
            // reCAPTCHA not verified, add red border and prevent form submission

            captchaWidget.style.border = '2px solid #e3342f';
            setCaptchaResponse(false);
           

            Swal.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Please verify Captcha.'
            });

            return false;
        } 

        if(verificationResponse == false)
        {

            return false;

        }
        //END Google Captcha

        if(referral) {
            window.location.href = "/cyber?c="+referral;
        } else {
            window.location.href = "/cyber";

        }
    }

    function verifyCaptcha(token) {
        //if(!isEmpty(token))
        //{    

        console.log('verifyCaptcha');
           
            setValidToken(token);

            var captchaWidget = document.getElementById('captchaV');

            captchaWidget.style.border = '';

            axios.post('/api/get-captcha', {
                response: token
            }).then(function (response) {
                    
                    let cresponse = response.data;
                    if(cresponse.success == true) {
                        setValidationResponse(true);
                        setVerificationResponse(true);
                       // grecaptcha.reset();
                    } else {
                        setValidationResponse(false);
                        setVerificationResponse(false);

                        Swal.fire({
                            title: 'Oops...',
                            icon: 'error',
                            text: 'Captcha verification Failed. Please try again.'
                        });

                        return false;
                    }
            }).catch(function (error) {
                    console.log(error);
            });

    }

    ReactGA.initialize('UA-144246801-1');
    return (
        <>
            <section id="header" className="d-flex align-items-center">
                <div className="row text-white">
                    <div className="col-10 col-sm-10 col-lg-7 ms-sm-4">
                        <h2>STAY SECURE, STAY INSURED  PROTECT YOUR DIGITAL LIFE</h2>
                    </div>
                </div>
            </section>
            <section id="body">
                <div className="container">
                    <div class="d-block d-lg-none">
                        <div class="row shadow title mt-n5 position-relative justify-content-center">
                            <div class="col-4 col-sm-2 align-self-center text-end">
                                <img src="../images/cyber-icon-2.png" alt="Travel Insurance" width={80}/>
                            </div>
                            <div class="col-8 col-sm-6 align-self-center text-center">
                                <h2 class="mb-2 me-sm-5 text-white font-weight-bold">CyberGuard</h2>
                            </div>
                        </div>
                    </div>
                    
                    <div class=" d-none d-lg-block">
                        <div className="row shadow title mt-n5 position-relative justify-content-center">
                            <div className="col-12 col-sm-2 align-self-center text-end py-3">
                                <img src="../images/cyber-icon-2.png" alt="Travel Insurance" width={120} />
                            </div>
                            <div className="col-8 col-sm-6 align-self-center text-center">
                                <h1 className="my-5 me-sm-5 text-white font-weight-bold">CyberGuard</h1>
                            </div>
                        </div>
                    </div>
                   
                    <div className="row content">
                        <div className="col-md-1"></div>
                        <div className="col-12 shadow bg-white rounded">
                            <div className="row text-primary">
                                <div className="col-12 mt-4 text-center">
                                    {/* <h5 className="text-primary font-weight-bold my-3">Affordable Online Critical Illness Insurance</h5> */}
                                    <p>
                                    This Personal Cyber Insurance is specifically designed to cover you for financial or material losses arising directly from any unexpected cyber threats or events. The policy provides cover for the following insured events and the coverage is on worldwide basis.
					                </p>
                                </div>
                            </div>
                            <div className="row my-3">
                                <div className="col-12 mt-1 text-center">
                                    {/* <h5 className="text-primary font-weight-bold mb-3">COVERAGE AND FEATURES AT A GLANCE</h5> */}
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Electronic Fund Transfer Fraud
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Online Retail Fraud
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Identity Theft
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Cyber Bullying
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        E-Commerce Purchase Protection
                                    </p>
                                    
                                </div>
                            </div>

                              

                               <div className="col-12 text-center">
                                    <p className="pdpa small">
                                        By clicking 'Get Quote' button, you confirm that you have read and agreed to our  <a target="_blank" href={process.env.MIX_INSTAPOL_PRIVACY}>Privacy Policy</a>,<br/>
                                        you are a Malaysian citizen and employed within Malaysia.
                                    </p>
                                </div>

                                {/* START Google Captcha Verification */}
                                <div className="col-12 text-center mb-3">
                                        <center>

                                       
                                        <ReCAPTCHA id="captchaV" ref={recaptchaRef} sitekey={process.env.MIX_GOOGLE_CAPTCHA_SITE_KEY} onChange={handleRecaptcha}/>

                                        <small id="verify-alert" className={(captchaResponse == true) ? 'd-none': 'text-danger'}>Please verify Captcha. </small>
                                        <small id="response-alert" className={(validationResponse == true) ? 'd-none': 'text-danger'}>Captcha verification Failed. Please try again. </small>
                                        <small id="gcresponse-success" className={(verificationResponse == true) ? 'text-success font-weight-bold': 'd-none'}>Verification Success.</small>
                                        </center>
                                </div>
                        </div>
                        <div className="col-md-1"></div>
                    </div>
                    <div className="row footer text-center mt-n2">
                        <div className="col-12">
			  
                            {/* <Button type="submit" className="btn btn-success" href="/cyber">Get Quote</Button>   */}

                            {props.referral ?
                                <button type="button" class="btn btn-success" onClick={() => { onClickNext(props.referral) }}>Get Quote</button>
                                // <a href={`/cyber?c=${props.referral}`} className="btn btn-success">Get Quote</a>
                            :   
                                <button type="button" class="btn btn-success" onClick={() => { onClickNext() }}>Get Quote</button>
                                // <a href="/cyber" className="btn btn-success">Get Quote</a>
                            }
                            <PromptConfirmation show={modalShow} onHide={() => setModalShow(false)} />              
                           
                        </div>
                        <div className="row d-flex d-sm-none mt-3">
                            <div className="col-12 text-center">
                                <small>* Terms and conditions apply.</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pds text-white mt-5">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p className="my-4 font-weight-bold">Please refer to the policy contract for more information on the benefits provided.</p>
                            </div>
                        </div>
                        <div className="row pds-row my-5">
				<div className="col-12 col-sm-6">
                                <a href="storage/pdf/pds.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/pdf-icon.png" alt="ProductTermsConditions.pdf" className="img" width={100} />
                                    </div>
                                     Personal Cyber Insurance<br></br>
                                     Product Disclosure Sheet
                                </a>
                            </div>

                            <div className="col-12 col-sm-6">
                                <a href="storage/pdf/pw.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/pdf-icon.png" alt="ProductDisclosure.pdf" className="img" width={100} />
                                    </div>
                                    Personal Cyber Insurance<br></br>
                                     Policy Wording
                                </a>
                            </div>
                        </div>
                    
                        <div className="row text-center justify-content-around">
                            <p className="col-8 font-weight-bold mt-2">
                                Underwritten by The Pacific Insurance Berhad (198201011878)
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

function PromptConfirmation(props) {
    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body style={{ padding: 0, position: 'relative' }}>
            {/* <button
                type="button"
                className="close"
                onClick={props.onHide}
                aria-label="Close"
                style={{ position: 'absolute', top: '10px', right: '10px', zIndex: '1', fontSize: '2.5rem', opacity: '0.7' }}
            >
                <span aria-hidden="true">&times;</span>
            </button> */}

             <button
							type="button"
							className="banner-btn-close position-absolute"
			style={{
				width: '40px',
				height: '40px',
				borderRadius: '50%',
				backgroundColor: 'white',
				boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
				border: 'none',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				color: 'black', // Ensure icon inside is visible
				fontSize: '20px', // Adjust icon/text size
				fontWeight: 'bold',
				top: '10px',
				right: '10px',
				zIndex: '1',
			}}
							data-bs-dismiss="modal"
							aria-label="Close"
							onClick={props.onHide} // Ensure this closes the modal
		><span aria-hidden="true">&times;</span></button>

            <a href="https://instapol.my/" target="_blank">
                <img
                    src={"../images/240112_Motor insurance-01.jpg"}
                    alt="Full-Sized Image"
                    className="img-fluid modal-image"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </a>
        </Modal.Body>
        <Modal.Footer style={{ padding: 0, position: 'relative' }}>
            <div style={{ width: '100%', height: '100%', textAlign: 'center', fontWeight: 'bold', cursor: 'pointer', color: '#9a5cd0'}} onClick={props.onHide}>
                Got It
            </div>
        </Modal.Footer>
    </Modal>
    
    );
}
